import type { VideoProgressMilestone } from '~kui/components/KUI/Core/Video/types';

import { VIDEO_PROGRESS_MILESTONES } from '~kui/components/KUI/Core/Video/types';

interface UseVideoProgressMilestonesOptions {
  onMilestone: (milestone: VideoProgressMilestone) => void;
}

/**
 * Turns a player's playback position into the shared progress milestones: each milestone is
 * reported once, the first time the viewer reaches it, and skipping back never re-reports one.
 * Feed it the fraction watched (0–1) from any provider's player.
 */
export const useVideoProgressMilestones = ({ onMilestone }: UseVideoProgressMilestonesOptions) => {
  let furthestMilestone = 0;

  const report = (fraction: number) => {
    VIDEO_PROGRESS_MILESTONES
      .filter(milestone => milestone > furthestMilestone && fraction * 100 >= milestone)
      .forEach((milestone) => {
        furthestMilestone = milestone;
        onMilestone(milestone);
      });
  };

  const reset = () => {
    furthestMilestone = 0;
  };

  return { report, reset };
};
